export default value => {
  if (isNaN(value)) return "N/A";

  const valueAsNumber = Number(value);

  if (valueAsNumber === 0) return "N/A";
  if (valueAsNumber < 0) return "N/A";

  if (valueAsNumber > 1000) {
    return "£" + (valueAsNumber / 1000).toFixed(1) + "K";
  }

  if (valueAsNumber > 1 && valueAsNumber < 1000) {
    return "£" + valueAsNumber.toFixed(0);
  }

  return "£" + valueAsNumber.toFixed(2);
};
